import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import OrderCreateEditForm from './Components/OrderCreateEditForm';
import OrderApi from './OrderApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: OrderCreateEditForm,
                getCreate: OrderApi.create,
                defaults: {},
                successMessage: "Order Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}